function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import { h } from 'preact';
import { UIPlugin } from '@uppy/core';
import StatusBar from '@uppy/status-bar';
import Informer from '@uppy/informer';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import findAllDOMElements from '@uppy/utils/lib/findAllDOMElements';
import toArray from '@uppy/utils/lib/toArray';
import getDroppedFiles from '@uppy/utils/lib/getDroppedFiles';
import { nanoid } from 'nanoid/non-secure';
import memoizeOne from 'memoize-one';
import * as trapFocus from './utils/trapFocus.js';
import createSuperFocus from './utils/createSuperFocus.js';
import DashboardUI from "./components/Dashboard.js";
var packageJson = {
  "version": "3.2.2"
};
import locale from './locale.js';
var memoize = memoizeOne.default || memoizeOne;
var TAB_KEY = 9;
var ESC_KEY = 27;

function createPromise() {
  var o = {};
  o.promise = new Promise(function (resolve, reject) {
    o.resolve = resolve;
    o.reject = reject;
  });
  return o;
}

function defaultPickerIcon() {
  return h("svg", {
    "aria-hidden": "true",
    focusable: "false",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, h("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
  }));
}
/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */


var _disabledNodes = /*#__PURE__*/_classPrivateFieldLooseKey("disabledNodes");

var _generateLargeThumbnailIfSingleFile = /*#__PURE__*/_classPrivateFieldLooseKey("generateLargeThumbnailIfSingleFile");

var _openFileEditorWhenFilesAdded = /*#__PURE__*/_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");

var _attachRenderFunctionToTarget = /*#__PURE__*/_classPrivateFieldLooseKey("attachRenderFunctionToTarget");

var _isTargetSupported = /*#__PURE__*/_classPrivateFieldLooseKey("isTargetSupported");

var _getAcquirers = /*#__PURE__*/_classPrivateFieldLooseKey("getAcquirers");

var _getProgressIndicators = /*#__PURE__*/_classPrivateFieldLooseKey("getProgressIndicators");

var _getEditors = /*#__PURE__*/_classPrivateFieldLooseKey("getEditors");

var Dashboard = /*#__PURE__*/function (_UIPlugin) {
  _inherits(Dashboard, _UIPlugin);

  var _super = _createSuper(Dashboard);

  function Dashboard(uppy, _opts) {
    var _this2;

    _classCallCheck(this, Dashboard);

    var _this;

    _this2 = _super.call(this, uppy, _opts);
    _this = _assertThisInitialized(_this2);
    Object.defineProperty(_assertThisInitialized(_this2), _disabledNodes, {
      writable: true,
      value: null
    });

    _this2.removeTarget = function (plugin) {
      var pluginState = _this2.getPluginState(); // filter out the one we want to remove


      var newTargets = pluginState.targets.filter(function (target) {
        return target.id !== plugin.id;
      });

      _this2.setPluginState({
        targets: newTargets
      });
    };

    _this2.addTarget = function (plugin) {
      var callerPluginId = plugin.id || plugin.constructor.name;
      var callerPluginName = plugin.title || callerPluginId;
      var callerPluginType = plugin.type;

      if (callerPluginType !== 'acquirer' && callerPluginType !== 'progressindicator' && callerPluginType !== 'editor') {
        var msg = 'Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor';

        _this2.uppy.log(msg, 'error');

        return undefined;
      }

      var target = {
        id: callerPluginId,
        name: callerPluginName,
        type: callerPluginType
      };

      var state = _this2.getPluginState();

      var newTargets = state.targets.slice();
      newTargets.push(target);

      _this2.setPluginState({
        targets: newTargets
      });

      return _this2.el;
    };

    _this2.hideAllPanels = function () {
      var state = _this2.getPluginState();

      var update = {
        activePickerPanel: false,
        showAddFilesPanel: false,
        activeOverlayType: null,
        fileCardFor: null,
        showFileEditor: false
      };

      if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) {
        // avoid doing a state update if nothing changed
        return;
      }

      _this2.setPluginState(update);
    };

    _this2.showPanel = function (id) {
      var _this2$getPluginState = _this2.getPluginState(),
          targets = _this2$getPluginState.targets;

      var activePickerPanel = targets.filter(function (target) {
        return target.type === 'acquirer' && target.id === id;
      })[0];

      _this2.setPluginState({
        activePickerPanel: activePickerPanel,
        activeOverlayType: 'PickerPanel'
      });

      _this2.uppy.emit('dashboard:show-panel', id);
    };

    _this2.canEditFile = function (file) {
      var _this2$getPluginState2 = _this2.getPluginState(),
          targets = _this2$getPluginState2.targets;

      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getEditors)[_getEditors](targets);

      return editors.some(function (target) {
        return _this2.uppy.getPlugin(target.id).canEditFile(file);
      });
    };

    _this2.openFileEditor = function (file) {
      var _this2$getPluginState3 = _this2.getPluginState(),
          targets = _this2$getPluginState3.targets;

      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getEditors)[_getEditors](targets);

      _this2.setPluginState({
        showFileEditor: true,
        fileCardFor: file.id || null,
        activeOverlayType: 'FileEditor'
      });

      editors.forEach(function (editor) {
        _this2.uppy.getPlugin(editor.id).selectFile(file);
      });
    };

    _this2.saveFileEditor = function () {
      var _this2$getPluginState4 = _this2.getPluginState(),
          targets = _this2$getPluginState4.targets;

      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getEditors)[_getEditors](targets);

      editors.forEach(function (editor) {
        _this2.uppy.getPlugin(editor.id).save();
      });

      _this2.hideAllPanels();
    };

    _this2.openModal = function () {
      var _createPromise = createPromise(),
          promise = _createPromise.promise,
          resolve = _createPromise.resolve; // save scroll position


      _this2.savedScrollPosition = window.pageYOffset; // save active element, so we can restore focus when modal is closed

      _this2.savedActiveElement = document.activeElement;

      if (_this2.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.add('uppy-Dashboard-isFixed');
      }

      if (_this2.opts.animateOpenClose && _this2.getPluginState().isClosing) {
        var handler = function handler() {
          _this2.setPluginState({
            isHidden: false
          });

          _this2.el.removeEventListener('animationend', handler, false);

          resolve();
        };

        _this2.el.addEventListener('animationend', handler, false);
      } else {
        _this2.setPluginState({
          isHidden: false
        });

        resolve();
      }

      if (_this2.opts.browserBackButtonClose) {
        _this2.updateBrowserHistory();
      } // handle ESC and TAB keys in modal dialog


      document.addEventListener('keydown', _this2.handleKeyDownInModal);

      _this2.uppy.emit('dashboard:modal-open');

      return promise;
    };

    _this2.closeModal = function (opts) {
      if (opts === void 0) {
        opts = {};
      }

      var _opts2 = opts,
          _opts2$manualClose = _opts2.manualClose,
          manualClose = _opts2$manualClose === void 0 ? true : _opts2$manualClose;

      var _this$getPluginState = _this.getPluginState(),
          isHidden = _this$getPluginState.isHidden,
          isClosing = _this$getPluginState.isClosing;

      if (isHidden || isClosing) {
        // short-circuit if animation is ongoing
        return undefined;
      }

      var _createPromise2 = createPromise(),
          promise = _createPromise2.promise,
          resolve = _createPromise2.resolve;

      if (_this.opts.disablePageScrollWhenModalOpen) {
        document.body.classList.remove('uppy-Dashboard-isFixed');
      }

      if (_this.opts.animateOpenClose) {
        _this.setPluginState({
          isClosing: true
        });

        var handler = function handler() {
          _this.setPluginState({
            isHidden: true,
            isClosing: false
          });

          _this.superFocus.cancel();

          _this.savedActiveElement.focus();

          _this.el.removeEventListener('animationend', handler, false);

          resolve();
        };

        _this.el.addEventListener('animationend', handler, false);
      } else {
        _this.setPluginState({
          isHidden: true
        });

        _this.superFocus.cancel();

        _this.savedActiveElement.focus();

        resolve();
      } // handle ESC and TAB keys in modal dialog


      document.removeEventListener('keydown', _this.handleKeyDownInModal);

      if (manualClose) {
        if (_this.opts.browserBackButtonClose) {
          var _history$state; // Make sure that the latest entry in the history state is our modal name
          // eslint-disable-next-line no-restricted-globals


          if ((_history$state = history.state) != null && _history$state[_this.modalName]) {
            // Go back in history to clear out the entry we created (ultimately closing the modal)
            // eslint-disable-next-line no-restricted-globals
            history.back();
          }
        }
      }

      _this.uppy.emit('dashboard:modal-closed');

      return promise;
    };

    _this2.isModalOpen = function () {
      return !_this2.getPluginState().isHidden || false;
    };

    _this2.requestCloseModal = function () {
      if (_this2.opts.onRequestCloseModal) {
        return _this2.opts.onRequestCloseModal();
      }

      return _this2.closeModal();
    };

    _this2.setDarkModeCapability = function (isDarkModeOn) {
      var _this2$uppy$getState = _this2.uppy.getState(),
          capabilities = _this2$uppy$getState.capabilities;

      _this2.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
          darkMode: isDarkModeOn
        })
      });
    };

    _this2.handleSystemDarkModeChange = function (event) {
      var isDarkModeOnNow = event.matches;

      _this2.uppy.log("[Dashboard] Dark mode is ".concat(isDarkModeOnNow ? 'on' : 'off'));

      _this2.setDarkModeCapability(isDarkModeOnNow);
    };

    _this2.toggleFileCard = function (show, fileID) {
      var file = _this2.uppy.getFile(fileID);

      if (show) {
        _this2.uppy.emit('dashboard:file-edit-start', file);
      } else {
        _this2.uppy.emit('dashboard:file-edit-complete', file);
      }

      _this2.setPluginState({
        fileCardFor: show ? fileID : null,
        activeOverlayType: show ? 'FileCard' : null
      });
    };

    _this2.toggleAddFilesPanel = function (show) {
      _this2.setPluginState({
        showAddFilesPanel: show,
        activeOverlayType: show ? 'AddFiles' : null
      });
    };

    _this2.addFiles = function (files) {
      var descriptors = files.map(function (file) {
        return {
          source: _this2.id,
          name: file.name,
          type: file.type,
          data: file,
          meta: {
            // path of the file relative to the ancestor directory the user selected.
            // e.g. 'docs/Old Prague/airbnb.pdf'
            relativePath: file.relativePath || file.webkitRelativePath || null
          }
        };
      });

      try {
        _this2.uppy.addFiles(descriptors);
      } catch (err) {
        _this2.uppy.log(err);
      }
    };

    _this2.startListeningToResize = function () {
      // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
      // and update containerWidth/containerHeight in plugin state accordingly.
      // Emits first event on initialization.
      _this2.resizeObserver = new ResizeObserver(function (entries) {
        var uppyDashboardInnerEl = entries[0];
        var _uppyDashboardInnerEl = uppyDashboardInnerEl.contentRect,
            width = _uppyDashboardInnerEl.width,
            height = _uppyDashboardInnerEl.height;

        _this2.setPluginState({
          containerWidth: width,
          containerHeight: height,
          areInsidesReadyToBeVisible: true
        });
      });

      _this2.resizeObserver.observe(_this2.el.querySelector('.uppy-Dashboard-inner')); // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view


      _this2.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(function () {
        var pluginState = _this2.getPluginState();

        var isModalAndClosed = !_this2.opts.inline && pluginState.isHidden;

        if ( // if ResizeObserver hasn't yet fired,
        !pluginState.areInsidesReadyToBeVisible // and it's not due to the modal being closed
        && !isModalAndClosed) {
          _this2.uppy.log('[Dashboard] resize event didn’t fire on time: defaulted to mobile layout', 'warning');

          _this2.setPluginState({
            areInsidesReadyToBeVisible: true
          });
        }
      }, 1000);
    };

    _this2.stopListeningToResize = function () {
      _this2.resizeObserver.disconnect();

      clearTimeout(_this2.makeDashboardInsidesVisibleAnywayTimeout);
    };

    _this2.recordIfFocusedOnUppyRecently = function (event) {
      if (_this2.el.contains(event.target)) {
        _this2.ifFocusedOnUppyRecently = true;
      } else {
        _this2.ifFocusedOnUppyRecently = false; // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
        //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
        //    previously run superFocus sometimes hits and moves focus back to Uppy.

        _this2.superFocus.cancel();
      }
    };

    _this2.disableInteractiveElements = function (disable) {
      var _classPrivateFieldLoo;

      var NODES_TO_DISABLE = ['a[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', '[role="button"]:not([disabled])'];
      var nodesToDisable = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _disabledNodes)[_disabledNodes]) != null ? _classPrivateFieldLoo : toArray(_this2.el.querySelectorAll(NODES_TO_DISABLE)).filter(function (node) {
        return !node.classList.contains('uppy-Dashboard-close');
      });

      var _iterator = _createForOfIteratorHelper(nodesToDisable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;

          // Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
          if (node.tagName === 'A') {
            node.setAttribute('aria-disabled', disable);
          } else {
            node.disabled = disable;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (disable) {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _disabledNodes)[_disabledNodes] = nodesToDisable;
      } else {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _disabledNodes)[_disabledNodes] = null;
      }

      _this2.dashboardIsDisabled = disable;
    };

    _this2.updateBrowserHistory = function () {
      var _history$state2; // Ensure history state does not already contain our modal name to avoid double-pushing
      // eslint-disable-next-line no-restricted-globals


      if (!((_history$state2 = history.state) != null && _history$state2[_this2.modalName])) {
        // Push to history so that the page is not lost on browser back button press
        // eslint-disable-next-line no-restricted-globals
        history.pushState(_objectSpread(_objectSpread({}, history.state), {}, _defineProperty({}, _this2.modalName, true)), '');
      } // Listen for back button presses


      window.addEventListener('popstate', _this2.handlePopState, false);
    };

    _this2.handlePopState = function (event) {
      var _event$state; // Close the modal if the history state no longer contains our modal name


      if (_this2.isModalOpen() && (!event.state || !event.state[_this2.modalName])) {
        _this2.closeModal({
          manualClose: false
        });
      } // When the browser back button is pressed and uppy is now the latest entry
      // in the history but the modal is closed, fix the history by removing the
      // uppy history entry.
      // This occurs when another entry is added into the history state while the
      // modal is open, and then the modal gets manually closed.
      // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)


      if (!_this2.isModalOpen() && (_event$state = event.state) != null && _event$state[_this2.modalName]) {
        // eslint-disable-next-line no-restricted-globals
        history.back();
      }
    };

    _this2.handleKeyDownInModal = function (event) {
      // close modal on esc key press
      if (event.keyCode === ESC_KEY) _this2.requestCloseModal(event); // trap focus on tab key press

      if (event.keyCode === TAB_KEY) trapFocus.forModal(event, _this2.getPluginState().activeOverlayType, _this2.el);
    };

    _this2.handleClickOutside = function () {
      if (_this2.opts.closeModalOnClickOutside) _this2.requestCloseModal();
    };

    _this2.handlePaste = function (event) {
      // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
      _this2.uppy.iteratePlugins(function (plugin) {
        if (plugin.type === 'acquirer') {
          // Every Plugin with .type acquirer can define handleRootPaste(event)
          plugin.handleRootPaste == null ? void 0 : plugin.handleRootPaste(event);
        }
      }); // Add all dropped files


      var files = toArray(event.clipboardData.files);

      if (files.length > 0) {
        _this2.uppy.log('[Dashboard] Files pasted');

        _this2.addFiles(files);
      }
    };

    _this2.handleInputChange = function (event) {
      event.preventDefault();
      var files = toArray(event.target.files);

      if (files.length > 0) {
        _this2.uppy.log('[Dashboard] Files selected through input');

        _this2.addFiles(files);
      }
    };

    _this2.handleDragOver = function (event) {
      var _this$opts$onDragOver, _this$opts;

      event.preventDefault();
      event.stopPropagation(); // Check if some plugin can handle the datatransfer without files —
      // for instance, the Url plugin can import a url

      var canSomePluginHandleRootDrop = function canSomePluginHandleRootDrop() {
        var somePluginCanHandleRootDrop = true;

        _this2.uppy.iteratePlugins(function (plugin) {
          if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) {
            somePluginCanHandleRootDrop = true;
          }
        });

        return somePluginCanHandleRootDrop;
      }; // Check if the "type" of the datatransfer object includes files


      var doesEventHaveFiles = function doesEventHaveFiles() {
        var types = event.dataTransfer.types;
        return types.some(function (type) {
          return type === 'Files';
        });
      }; // Deny drop, if no plugins can handle datatransfer, there are no files,
      // or when opts.disabled is set, or new uploads are not allowed


      var somePluginCanHandleRootDrop = canSomePluginHandleRootDrop(event);
      var hasFiles = doesEventHaveFiles(event);

      if (!somePluginCanHandleRootDrop && !hasFiles || _this2.opts.disabled // opts.disableLocalFiles should only be taken into account if no plugins
      // can handle the datatransfer
      || _this2.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !_this2.uppy.getState().allowNewUpload) {
        event.dataTransfer.dropEffect = 'none'; // eslint-disable-line no-param-reassign

        clearTimeout(_this2.removeDragOverClassTimeout);
        return;
      } // Add a small (+) icon on drop
      // (and prevent browsers from interpreting this as files being _moved_ into the
      // browser, https://github.com/transloadit/uppy/issues/1978).


      event.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign

      clearTimeout(_this2.removeDragOverClassTimeout);

      _this2.setPluginState({
        isDraggingOver: true
      });

      (_this$opts$onDragOver = (_this$opts = _this2.opts).onDragOver) == null ? void 0 : _this$opts$onDragOver.call(_this$opts, event);
    };

    _this2.handleDragLeave = function (event) {
      var _this$opts$onDragLeav, _this$opts2;

      event.preventDefault();
      event.stopPropagation();
      clearTimeout(_this2.removeDragOverClassTimeout); // Timeout against flickering, this solution is taken from drag-drop library.
      // Solution with 'pointer-events: none' didn't work across browsers.

      _this2.removeDragOverClassTimeout = setTimeout(function () {
        _this2.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts2 = _this2.opts).onDragLeave) == null ? void 0 : _this$opts$onDragLeav.call(_this$opts2, event);
    };

    _this2.handleDrop = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var _this$opts$onDrop, _this$opts3, executedDropErrorOnce, logDropError, files;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                event.stopPropagation();
                clearTimeout(_this2.removeDragOverClassTimeout);

                _this2.setPluginState({
                  isDraggingOver: false
                }); // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root


                _this2.uppy.iteratePlugins(function (plugin) {
                  if (plugin.type === 'acquirer') {
                    // Every Plugin with .type acquirer can define handleRootDrop(event)
                    plugin.handleRootDrop == null ? void 0 : plugin.handleRootDrop(event);
                  }
                }); // Add all dropped files


                executedDropErrorOnce = false;

                logDropError = function logDropError(error) {
                  _this2.uppy.log(error, 'error'); // In practice all drop errors are most likely the same,
                  // so let's just show one to avoid overwhelming the user


                  if (!executedDropErrorOnce) {
                    _this2.uppy.info(error.message, 'error');

                    executedDropErrorOnce = true;
                  }
                }; // Add all dropped files


                _context.next = 9;
                return getDroppedFiles(event.dataTransfer, {
                  logDropError: logDropError
                });

              case 9:
                files = _context.sent;

                if (files.length > 0) {
                  _this2.uppy.log('[Dashboard] Files dropped');

                  _this2.addFiles(files);
                }

                (_this$opts$onDrop = (_this$opts3 = _this2.opts).onDrop) == null ? void 0 : _this$opts$onDrop.call(_this$opts3, event);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this2.handleRequestThumbnail = function (file) {
      if (!_this2.opts.waitForThumbnailsBeforeUpload) {
        _this2.uppy.emit('thumbnail:request', file);
      }
    };

    _this2.handleCancelThumbnail = function (file) {
      if (!_this2.opts.waitForThumbnailsBeforeUpload) {
        _this2.uppy.emit('thumbnail:cancel', file);
      }
    };

    _this2.handleKeyDownInInline = function (event) {
      // Trap focus on tab key press.
      if (event.keyCode === TAB_KEY) trapFocus.forInline(event, _this2.getPluginState().activeOverlayType, _this2.el);
    };

    _this2.handlePasteOnBody = function (event) {
      var isFocusInOverlay = _this2.el.contains(document.activeElement);

      if (isFocusInOverlay) {
        _this2.handlePaste(event);
      }
    };

    _this2.handleComplete = function (_ref) {
      var failed = _ref.failed;

      if (_this2.opts.closeAfterFinish && failed.length === 0) {
        // All uploads are done
        _this2.requestCloseModal();
      }
    };

    _this2.handleCancelRestore = function () {
      _this2.uppy.emit('restore-canceled');
    };

    Object.defineProperty(_assertThisInitialized(_this2), _generateLargeThumbnailIfSingleFile, {
      writable: true,
      value: function value() {
        if (_this2.opts.disableThumbnailGenerator) {
          return;
        }

        var LARGE_THUMBNAIL = 600;

        var files = _this2.uppy.getFiles();

        if (files.length === 1) {
          var thumbnailGenerator = _this2.uppy.getPlugin("".concat(_this2.id, ":ThumbnailGenerator"));

          thumbnailGenerator == null ? void 0 : thumbnailGenerator.setOptions({
            thumbnailWidth: LARGE_THUMBNAIL
          });

          var fileForThumbnail = _objectSpread(_objectSpread({}, files[0]), {}, {
            preview: undefined
          });

          thumbnailGenerator.requestThumbnail(fileForThumbnail).then(function () {
            thumbnailGenerator == null ? void 0 : thumbnailGenerator.setOptions({
              thumbnailWidth: _this2.opts.thumbnailWidth
            });
          });
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _openFileEditorWhenFilesAdded, {
      writable: true,
      value: function value(files) {
        var firstFile = files[0];

        if (_this2.canEditFile(firstFile)) {
          _this2.openFileEditor(firstFile);
        }
      }
    });

    _this2.initEvents = function () {
      // Modal open button
      if (_this2.opts.trigger && !_this2.opts.inline) {
        var showModalTrigger = findAllDOMElements(_this2.opts.trigger);

        if (showModalTrigger) {
          showModalTrigger.forEach(function (trigger) {
            return trigger.addEventListener('click', _this2.openModal);
          });
        } else {
          _this2.uppy.log('Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself', 'warning');
        }
      }

      _this2.startListeningToResize();

      document.addEventListener('paste', _this2.handlePasteOnBody);

      _this2.uppy.on('plugin-remove', _this2.removeTarget);

      _this2.uppy.on('file-added', _this2.hideAllPanels);

      _this2.uppy.on('dashboard:modal-closed', _this2.hideAllPanels);

      _this2.uppy.on('file-editor:complete', _this2.hideAllPanels);

      _this2.uppy.on('complete', _this2.handleComplete);

      _this2.uppy.on('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);

      _this2.uppy.on('file-removed', _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]); // ___Why fire on capture?
      //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.


      document.addEventListener('focus', _this2.recordIfFocusedOnUppyRecently, true);
      document.addEventListener('click', _this2.recordIfFocusedOnUppyRecently, true);

      if (_this2.opts.inline) {
        _this2.el.addEventListener('keydown', _this2.handleKeyDownInInline);
      }

      if (_this2.opts.autoOpenFileEditor) {
        _this2.uppy.on('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };

    _this2.removeEvents = function () {
      var showModalTrigger = findAllDOMElements(_this2.opts.trigger);

      if (!_this2.opts.inline && showModalTrigger) {
        showModalTrigger.forEach(function (trigger) {
          return trigger.removeEventListener('click', _this2.openModal);
        });
      }

      _this2.stopListeningToResize();

      document.removeEventListener('paste', _this2.handlePasteOnBody);
      window.removeEventListener('popstate', _this2.handlePopState, false);

      _this2.uppy.off('plugin-remove', _this2.removeTarget);

      _this2.uppy.off('file-added', _this2.hideAllPanels);

      _this2.uppy.off('dashboard:modal-closed', _this2.hideAllPanels);

      _this2.uppy.off('file-editor:complete', _this2.hideAllPanels);

      _this2.uppy.off('complete', _this2.handleComplete);

      _this2.uppy.off('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);

      _this2.uppy.off('file-removed', _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _generateLargeThumbnailIfSingleFile)[_generateLargeThumbnailIfSingleFile]);

      document.removeEventListener('focus', _this2.recordIfFocusedOnUppyRecently);
      document.removeEventListener('click', _this2.recordIfFocusedOnUppyRecently);

      if (_this2.opts.inline) {
        _this2.el.removeEventListener('keydown', _this2.handleKeyDownInInline);
      }

      if (_this2.opts.autoOpenFileEditor) {
        _this2.uppy.off('files-added', _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _openFileEditorWhenFilesAdded)[_openFileEditorWhenFilesAdded]);
      }
    };

    _this2.superFocusOnEachUpdate = function () {
      var isFocusInUppy = _this2.el.contains(document.activeElement); // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)


      var isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
      var isInformerHidden = _this2.uppy.getState().info.length === 0;
      var isModal = !_this2.opts.inline;

      if ( // If update is connected to showing the Informer - let the screen reader calmly read it.
      isInformerHidden && ( // If we are in a modal - always superfocus without concern for other elements
      // on the page (user is unlikely to want to interact with the rest of the page)
      isModal // If we are already inside of Uppy, or
      || isFocusInUppy // If we are not focused on anything BUT we have already, at least once, focused on uppy
      //   1. We focus when isFocusNowhere, because when the element we were focused
      //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
      //      something somewhere else on the page, - focus won't be 'nowhere'.
      //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
      //      to avoid focus jumps if we do something else on the page.
      //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
      //                     when file is uploading, - navigate via tab to the checkbox,
      //                     try to press space multiple times. Focus will jump to Uppy.
      || isFocusNowhere && _this2.ifFocusedOnUppyRecently)) {
        _this2.superFocus(_this2.el, _this2.getPluginState().activeOverlayType);
      } else {
        _this2.superFocus.cancel();
      }
    };

    _this2.afterUpdate = function () {
      if (_this2.opts.disabled && !_this2.dashboardIsDisabled) {
        _this2.disableInteractiveElements(true);

        return;
      }

      if (!_this2.opts.disabled && _this2.dashboardIsDisabled) {
        _this2.disableInteractiveElements(false);
      }

      _this2.superFocusOnEachUpdate();
    };

    _this2.saveFileCard = function (meta, fileID) {
      _this2.uppy.setFileMeta(fileID, meta);

      _this2.toggleFileCard(false, fileID);
    };

    Object.defineProperty(_assertThisInitialized(_this2), _attachRenderFunctionToTarget, {
      writable: true,
      value: function value(target) {
        var plugin = _this2.uppy.getPlugin(target.id);

        return _objectSpread(_objectSpread({}, target), {}, {
          icon: plugin.icon || _this2.opts.defaultPickerIcon,
          render: plugin.render
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _isTargetSupported, {
      writable: true,
      value: function value(target) {
        var plugin = _this2.uppy.getPlugin(target.id); // If the plugin does not provide a `supported` check, assume the plugin works everywhere.


        if (typeof plugin.isSupported !== 'function') {
          return true;
        }

        return plugin.isSupported();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getAcquirers, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'acquirer' && _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _isTargetSupported)[_isTargetSupported](target);
        }).map(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getProgressIndicators, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'progressindicator';
        }).map(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getEditors, {
      writable: true,
      value: memoize(function (targets) {
        return targets.filter(function (target) {
          return target.type === 'editor';
        }).map(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _attachRenderFunctionToTarget)[_attachRenderFunctionToTarget]);
      })
    });

    _this2.render = function (state) {
      var pluginState = _this2.getPluginState();

      var files = state.files,
          capabilities = state.capabilities,
          allowNewUpload = state.allowNewUpload;

      var _this2$uppy$getObject = _this2.uppy.getObjectOfFilesPerState(),
          newFiles = _this2$uppy$getObject.newFiles,
          uploadStartedFiles = _this2$uppy$getObject.uploadStartedFiles,
          completeFiles = _this2$uppy$getObject.completeFiles,
          erroredFiles = _this2$uppy$getObject.erroredFiles,
          inProgressFiles = _this2$uppy$getObject.inProgressFiles,
          inProgressNotPausedFiles = _this2$uppy$getObject.inProgressNotPausedFiles,
          processingFiles = _this2$uppy$getObject.processingFiles,
          isUploadStarted = _this2$uppy$getObject.isUploadStarted,
          isAllComplete = _this2$uppy$getObject.isAllComplete,
          isAllErrored = _this2$uppy$getObject.isAllErrored,
          isAllPaused = _this2$uppy$getObject.isAllPaused;

      var acquirers = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getAcquirers)[_getAcquirers](pluginState.targets);

      var progressindicators = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getProgressIndicators)[_getProgressIndicators](pluginState.targets);

      var editors = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getEditors)[_getEditors](pluginState.targets);

      var theme;

      if (_this2.opts.theme === 'auto') {
        theme = capabilities.darkMode ? 'dark' : 'light';
      } else {
        theme = _this2.opts.theme;
      }

      if (['files', 'folders', 'both'].indexOf(_this2.opts.fileManagerSelectionType) < 0) {
        _this2.opts.fileManagerSelectionType = 'files'; // eslint-disable-next-line no-console

        console.warn("Unsupported option for \"fileManagerSelectionType\". Using default of \"".concat(_this2.opts.fileManagerSelectionType, "\"."));
      }

      return DashboardUI({
        state: state,
        isHidden: pluginState.isHidden,
        files: files,
        newFiles: newFiles,
        uploadStartedFiles: uploadStartedFiles,
        completeFiles: completeFiles,
        erroredFiles: erroredFiles,
        inProgressFiles: inProgressFiles,
        inProgressNotPausedFiles: inProgressNotPausedFiles,
        processingFiles: processingFiles,
        isUploadStarted: isUploadStarted,
        isAllComplete: isAllComplete,
        isAllErrored: isAllErrored,
        isAllPaused: isAllPaused,
        totalFileCount: Object.keys(files).length,
        totalProgress: state.totalProgress,
        allowNewUpload: allowNewUpload,
        acquirers: acquirers,
        theme: theme,
        disabled: _this2.opts.disabled,
        disableLocalFiles: _this2.opts.disableLocalFiles,
        direction: _this2.opts.direction,
        activePickerPanel: pluginState.activePickerPanel,
        showFileEditor: pluginState.showFileEditor,
        saveFileEditor: _this2.saveFileEditor,
        disableInteractiveElements: _this2.disableInteractiveElements,
        animateOpenClose: _this2.opts.animateOpenClose,
        isClosing: pluginState.isClosing,
        progressindicators: progressindicators,
        editors: editors,
        autoProceed: _this2.uppy.opts.autoProceed,
        id: _this2.id,
        closeModal: _this2.requestCloseModal,
        handleClickOutside: _this2.handleClickOutside,
        handleInputChange: _this2.handleInputChange,
        handlePaste: _this2.handlePaste,
        inline: _this2.opts.inline,
        showPanel: _this2.showPanel,
        hideAllPanels: _this2.hideAllPanels,
        i18n: _this2.i18n,
        i18nArray: _this2.i18nArray,
        uppy: _this2.uppy,
        note: _this2.opts.note,
        recoveredState: state.recoveredState,
        metaFields: pluginState.metaFields,
        resumableUploads: capabilities.resumableUploads || false,
        individualCancellation: capabilities.individualCancellation,
        isMobileDevice: capabilities.isMobileDevice,
        fileCardFor: pluginState.fileCardFor,
        toggleFileCard: _this2.toggleFileCard,
        toggleAddFilesPanel: _this2.toggleAddFilesPanel,
        showAddFilesPanel: pluginState.showAddFilesPanel,
        saveFileCard: _this2.saveFileCard,
        openFileEditor: _this2.openFileEditor,
        canEditFile: _this2.canEditFile,
        width: _this2.opts.width,
        height: _this2.opts.height,
        showLinkToFileUploadResult: _this2.opts.showLinkToFileUploadResult,
        fileManagerSelectionType: _this2.opts.fileManagerSelectionType,
        proudlyDisplayPoweredByUppy: _this2.opts.proudlyDisplayPoweredByUppy,
        hideCancelButton: _this2.opts.hideCancelButton,
        hideRetryButton: _this2.opts.hideRetryButton,
        hidePauseResumeButton: _this2.opts.hidePauseResumeButton,
        showRemoveButtonAfterComplete: _this2.opts.showRemoveButtonAfterComplete,
        containerWidth: pluginState.containerWidth,
        containerHeight: pluginState.containerHeight,
        areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
        isTargetDOMEl: _this2.isTargetDOMEl,
        parentElement: _this2.el,
        allowedFileTypes: _this2.uppy.opts.restrictions.allowedFileTypes,
        maxNumberOfFiles: _this2.uppy.opts.restrictions.maxNumberOfFiles,
        requiredMetaFields: _this2.uppy.opts.restrictions.requiredMetaFields,
        showSelectedFiles: _this2.opts.showSelectedFiles,
        showNativePhotoCameraButton: _this2.opts.showNativePhotoCameraButton,
        showNativeVideoCameraButton: _this2.opts.showNativeVideoCameraButton,
        nativeCameraFacingMode: _this2.opts.nativeCameraFacingMode,
        handleCancelRestore: _this2.handleCancelRestore,
        handleRequestThumbnail: _this2.handleRequestThumbnail,
        handleCancelThumbnail: _this2.handleCancelThumbnail,
        // drag props
        isDraggingOver: pluginState.isDraggingOver,
        handleDragOver: _this2.handleDragOver,
        handleDragLeave: _this2.handleDragLeave,
        handleDrop: _this2.handleDrop
      });
    };

    _this2.discoverProviderPlugins = function () {
      _this2.uppy.iteratePlugins(function (plugin) {
        if (plugin && !plugin.target && plugin.opts && plugin.opts.target === _this2.constructor) {
          _this2.addTarget(plugin);
        }
      });
    };

    _this2.install = function () {
      // Set default state for Dashboard
      _this2.setPluginState({
        isHidden: true,
        fileCardFor: null,
        activeOverlayType: null,
        showAddFilesPanel: false,
        activePickerPanel: false,
        showFileEditor: false,
        metaFields: _this2.opts.metaFields,
        targets: [],
        // We'll make them visible once .containerWidth is determined
        areInsidesReadyToBeVisible: false,
        isDraggingOver: false
      });

      var _this2$opts = _this2.opts,
          inline = _this2$opts.inline,
          closeAfterFinish = _this2$opts.closeAfterFinish;

      if (inline && closeAfterFinish) {
        throw new Error('[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.');
      }

      var _this2$uppy$opts = _this2.uppy.opts,
          allowMultipleUploads = _this2$uppy$opts.allowMultipleUploads,
          allowMultipleUploadBatches = _this2$uppy$opts.allowMultipleUploadBatches;

      if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) {
        _this2.uppy.log('[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true', 'warning');
      }

      var target = _this2.opts.target;

      if (target) {
        _this2.mount(target, _assertThisInitialized(_this2));
      }

      var plugins = _this2.opts.plugins || [];
      plugins.forEach(function (pluginID) {
        var plugin = _this2.uppy.getPlugin(pluginID);

        if (plugin) {
          plugin.mount(_assertThisInitialized(_this2), plugin);
        }
      });

      if (!_this2.opts.disableStatusBar) {
        _this2.uppy.use(StatusBar, {
          id: "".concat(_this2.id, ":StatusBar"),
          target: _assertThisInitialized(_this2),
          hideUploadButton: _this2.opts.hideUploadButton,
          hideRetryButton: _this2.opts.hideRetryButton,
          hidePauseResumeButton: _this2.opts.hidePauseResumeButton,
          hideCancelButton: _this2.opts.hideCancelButton,
          showProgressDetails: _this2.opts.showProgressDetails,
          hideAfterFinish: _this2.opts.hideProgressAfterFinish,
          locale: _this2.opts.locale,
          doneButtonHandler: _this2.opts.doneButtonHandler
        });
      }

      if (!_this2.opts.disableInformer) {
        _this2.uppy.use(Informer, {
          id: "".concat(_this2.id, ":Informer"),
          target: _assertThisInitialized(_this2)
        });
      }

      if (!_this2.opts.disableThumbnailGenerator) {
        _this2.uppy.use(ThumbnailGenerator, {
          id: "".concat(_this2.id, ":ThumbnailGenerator"),
          thumbnailWidth: _this2.opts.thumbnailWidth,
          thumbnailHeight: _this2.opts.thumbnailHeight,
          thumbnailType: _this2.opts.thumbnailType,
          waitForThumbnailsBeforeUpload: _this2.opts.waitForThumbnailsBeforeUpload,
          // If we don't block on thumbnails, we can lazily generate them
          lazy: !_this2.opts.waitForThumbnailsBeforeUpload
        });
      } // Dark Mode / theme


      _this2.darkModeMediaQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
      var isDarkModeOnFromTheStart = _this2.darkModeMediaQuery ? _this2.darkModeMediaQuery.matches : false;

      _this2.uppy.log("[Dashboard] Dark mode is ".concat(isDarkModeOnFromTheStart ? 'on' : 'off'));

      _this2.setDarkModeCapability(isDarkModeOnFromTheStart);

      if (_this2.opts.theme === 'auto') {
        _this2.darkModeMediaQuery.addListener(_this2.handleSystemDarkModeChange);
      }

      _this2.discoverProviderPlugins();

      _this2.initEvents();
    };

    _this2.uninstall = function () {
      if (!_this2.opts.disableInformer) {
        var informer = _this2.uppy.getPlugin("".concat(_this2.id, ":Informer")); // Checking if this plugin exists, in case it was removed by uppy-core
        // before the Dashboard was.


        if (informer) _this2.uppy.removePlugin(informer);
      }

      if (!_this2.opts.disableStatusBar) {
        var statusBar = _this2.uppy.getPlugin("".concat(_this2.id, ":StatusBar"));

        if (statusBar) _this2.uppy.removePlugin(statusBar);
      }

      if (!_this2.opts.disableThumbnailGenerator) {
        var thumbnail = _this2.uppy.getPlugin("".concat(_this2.id, ":ThumbnailGenerator"));

        if (thumbnail) _this2.uppy.removePlugin(thumbnail);
      }

      var plugins = _this2.opts.plugins || [];
      plugins.forEach(function (pluginID) {
        var plugin = _this2.uppy.getPlugin(pluginID);

        if (plugin) plugin.unmount();
      });

      if (_this2.opts.theme === 'auto') {
        _this2.darkModeMediaQuery.removeListener(_this2.handleSystemDarkModeChange);
      }

      _this2.unmount();

      _this2.removeEvents();
    };

    _this2.id = _this2.opts.id || 'Dashboard';
    _this2.title = 'Dashboard';
    _this2.type = 'orchestrator';
    _this2.modalName = "uppy-Dashboard-".concat(nanoid());
    _this2.defaultLocale = locale; // set default options, must be kept in sync with packages/@uppy/react/src/DashboardModal.js

    var defaultOptions = {
      target: 'body',
      metaFields: [],
      trigger: null,
      inline: false,
      width: 750,
      height: 550,
      thumbnailWidth: 280,
      thumbnailType: 'image/jpeg',
      waitForThumbnailsBeforeUpload: false,
      defaultPickerIcon: defaultPickerIcon,
      showLinkToFileUploadResult: false,
      showProgressDetails: false,
      hideUploadButton: false,
      hideCancelButton: false,
      hideRetryButton: false,
      hidePauseResumeButton: false,
      hideProgressAfterFinish: false,
      doneButtonHandler: function doneButtonHandler() {
        _this2.uppy.cancelAll();

        _this2.requestCloseModal();
      },
      note: null,
      closeModalOnClickOutside: false,
      closeAfterFinish: false,
      disableStatusBar: false,
      disableInformer: false,
      disableThumbnailGenerator: false,
      disablePageScrollWhenModalOpen: true,
      animateOpenClose: true,
      fileManagerSelectionType: 'files',
      proudlyDisplayPoweredByUppy: true,
      onRequestCloseModal: function onRequestCloseModal() {
        return _this2.closeModal();
      },
      showSelectedFiles: true,
      showRemoveButtonAfterComplete: false,
      browserBackButtonClose: false,
      showNativePhotoCameraButton: false,
      showNativeVideoCameraButton: false,
      theme: 'light',
      autoOpenFileEditor: false,
      disabled: false,
      disableLocalFiles: false
    }; // merge default options with the ones set by user

    _this2.opts = _objectSpread(_objectSpread({}, defaultOptions), _opts);

    _this2.i18nInit();

    _this2.superFocus = createSuperFocus();
    _this2.ifFocusedOnUppyRecently = false; // Timeouts

    _this2.makeDashboardInsidesVisibleAnywayTimeout = null;
    _this2.removeDragOverClassTimeout = null;
    return _this2;
  }

  return _createClass(Dashboard);
}(UIPlugin);

export { Dashboard as default };
Dashboard.VERSION = packageJson.version;